"use client";

import { useEffect } from "react";

import { installStaleServerActionRecovery } from "@/lib/deploy/staleServerAction";

/**
 * Mount-once installer for the Server Action deploy-skew self-heal (IDD-18).
 * Renders nothing; lives in the root layout so the listeners are always on.
 */
export default function StaleServerActionRecovery(): null {
  useEffect(() => {
    installStaleServerActionRecovery();
  }, []);
  return null;
}
